import React from 'react';
import { useSearchParams } from 'react-router-dom';
import NaverDiscoverClient from './components/NaverDiscoverClient';

const NaverDiscoverPage = () => {
  const [searchParams] = useSearchParams();
  const createType = searchParams.get('create');
  return <NaverDiscoverClient initialCreateType={createType} />;
};

export default NaverDiscoverPage;
